module.exports = __webpack_public_path__ + "img/00035.2e061650.webp";